import { render, staticRenderFns } from "./BasePopover.vue?vue&type=template&id=0f9e6f4e&scoped=true"
import script from "./BasePopover.js?vue&type=script&lang=js&external"
export * from "./BasePopover.js?vue&type=script&lang=js&external"
import style0 from "./BasePopover.scss?vue&type=style&index=0&id=0f9e6f4e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9e6f4e",
  null
  
)

export default component.exports